export default __webpack_public_path__ + "static/media/news3.e9eba4a2.png";